import { render, staticRenderFns } from "./ButtonDefault.vue?vue&type=template&id=65f8b9d9"
import script from "./ButtonDefault.vue?vue&type=script&lang=js"
export * from "./ButtonDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports